export default __webpack_public_path__ + "static/media/close_filter.ce5a07da.svg";